// Presentation grouping never merges execution requests or their permissions.
export const getDeferredRetryDate = (job, now = Date.now()) => {
  const requests = Array.isArray(job?.group_jobs) ? job.group_jobs : [job];
  if (!requests.length) return null;
  let earliest = Infinity;
  for (const request of requests) {
    if (request?.state !== 'scheduled' || typeof request.next_attempt_at !== 'string') return null;
    const timestamp = request.next_attempt_at.trim();
    // QueueStore persists naive ISO timestamps in UTC, not browser local time.
    const milliseconds = Date.parse(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(timestamp) ? timestamp : `${timestamp}Z`);
    if (!Number.isFinite(milliseconds) || milliseconds <= now) return null;
    earliest = Math.min(earliest, milliseconds);
  }
  return new Date(earliest);
};

export const groupPostProcessingJobs = (jobs) => {
  const groups = new Map();
  const priorities = { processing: 0, finalizing: 0, blocked: 1, awaiting_review: 2 };
  jobs.forEach((job, index) => {
    const project = job.project_id ?? job.case_id;
    const tags = [...new Set(Array.isArray(job.output_tags) ? job.output_tags : (job.tag ? [job.tag] : []))].sort();
    const widget = job.widget_id ?? (tags.length === 1 && job.action_type === 'generatewidget' ? tags[0] : null);
    const key = widget !== null ? JSON.stringify([project, widget]) : `job:${job.job_id ?? index}`;
    const group = groups.get(key);
    const count = Math.max(1, Number.parseInt(job.job_count, 10) || 1);
    if (!group) {
      groups.set(key, { ...job, group_key: key, job_count: count, group_jobs: [job] });
    } else {
      group.group_jobs.push(job);
      group.job_count += count;
      if ((priorities[job.state] ?? 3) < (priorities[group.state] ?? 3)) group.state = job.state;
    }
  });
  return [...groups.values()];
};
